import { DELAY } from 'src/app/core/utils/constants';
import { PETICIONES } from './../utils/constants';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Statistics } from '../../core/entities/statistics.model';
import { StatisticsFiltro } from '../../core/entities/statisticsfiltro.model';
import { delay } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class StatisticsService {
    readonly BASE: any = PETICIONES.statistics;

    constructor(private http: HttpClient) { }


    /**
    * @description
    * Obtiene todas las statistics
    */
    public findAll(): Observable<any> {
        return this.http.get(this.BASE.findAll).pipe(delay(DELAY));
    }


    /**
    * @description
    * Obtiene una statistic por su id
    */
    public findById(id: number): Observable<any> {
        let idstatistics: string = (id !== undefined && id !== null ? id + "" : "");
        return this.http.get(this.BASE.findById + "/" + idstatistics).pipe(delay(DELAY));
    }


    /**
    * @description
    * Guarda una statistic en la base de datos
    */
    public postStatistics(statistics: Statistics): Observable<any> {
        const json = JSON.stringify(statistics);
        const headers = new HttpHeaders().set('Content-Type', 'application/json;charset=UTF-8');
        return this.http.post(this.BASE.postStatistics, json, {headers: headers}).pipe(delay(DELAY));
    }

    /**
    * @description
    * Mandamos un una statisticfiltro para busqueda filtro
    */
    public postStatisticsFiltro(filtro: StatisticsFiltro): Observable<any> {
        const json = JSON.stringify(filtro);
        const headers = new HttpHeaders().set('Content-Type', 'application/json;charset=UTF-8');
        return this.http.post(this.BASE.postStatisticsFiltro, json, {headers: headers}).pipe(delay(DELAY));
    }



    /**
    * @description
    * Guarda una statistic en la base de datos
    */
    public postStatisticsSesion(statistics: Statistics, hora: number): Observable<any> {
        const json = JSON.stringify(statistics);
        const headers = new HttpHeaders().set('Content-Type', 'application/json;charset=UTF-8');
        return this.http.post(this.BASE.postStatisticsSesion + "/" + hora , json, {headers: headers}).pipe(delay(DELAY));
    }


    /**
    * @description
    * Borra una statistics en la base de datos
    */
    public deleteStatistics(statistics: Statistics): Observable<any> {
        let idstatistics: string = (statistics.id !== undefined && statistics.id !== null ? statistics.id + "" : "");
        return this.http.get(this.BASE.deleteStatistics + "/" + idstatistics).pipe(delay(DELAY));
    }

}